import React from 'react';
import {useEventSettings} from '../../../../../../data/hooks/events/useEventSettings';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';

function StepExhibitors(props) {
    const {eventId} = props,
        i18n = useI18n(),
        settings = useEventSettings(eventId),
        visible = !!settings.exhibitors_label?.length ,
        done = false,
        label = i18n['start.view_exhibitors'].replace('{0}', settings.exhibitors_label ?? '');

    return (
        <StartNetworkingStep href={['/events', eventId, 'exhibitors'].join('/')} visible={visible} done={done}>
            {label}
        </StartNetworkingStep>
    );
}

export default StepExhibitors;
